<style>

.outer{
	z-index: 1000;
	position: fixed;
	top: 0;
  bottom: 0;
	left: 0;
  right: 0;
	/* background-color: #999; */
  background-color: rgba(0,0,0,0.8);
  color: white;
  font-size: 24px;
  overflow-y: auto;
  text-align: center;
}

.inner{
  margin-top: 200px;
  font-size: 30px;
}
</style>

{#if internalShow}
<div class="outer">
  <div class="inner">
    <Spinner></Spinner>
    {#if message}
      {message}
    {:else}
      Loading greatness
    {/if}
  </div>
</div>
{/if}

<script>

import Spinner from "./Spinner.svelte";

export let show = false;
export let message = "";
export let immediate = true;

let internalShow = false;
let timerHandle = null;

$:{
  if (show) startTimer();
  if (show == false) stopTimer();
}


function startTimer() {
  if (immediate == true) {
    internalShow = true;
  } else {
    timerHandle = setTimeout(() => {internalShow = true}, 750);
  }
}


function stopTimer() {
  if (timerHandle != null) {
    clearTimeout(timerHandle);
    timerHandle = null;
  }
  internalShow = false;
}


</script>